
import AuthStore from './../store/AuthStore.js';
import settings from './../settings';
import {paths} from './../App';
import i18n from "i18next";
import { Container, Inject, Service, Token} from 'typedi';

export const host = process.env.NODE_ENV === 'development' ? settings.hostDefault : settings.hostServer;
export const port = process.env.NODE_ENV === 'development' ? settings.portDefault : settings.portServer;
export const pathname = process.env.NODE_ENV === 'development' ? settings.pathnameDefault : settings.pathnameServer;

let refreshTokenRequesting = false
async function refreshToken(){
    if(refreshTokenRequesting) return
    try{
      refreshTokenRequesting = true;
      let data = await fetchQueue('auth/refreshToken');
      if(data.message){
        setTimeout(this.reset, settings.TIMEOUT_RETRY); 
      }else if(data.info){
        // nop
      }else{
        await AuthStore.authorize(data);
      }
    }catch(err){
      setTimeout(this.reset, settings.TIMEOUT_RETRY);   
    }finally{
      refreshTokenRequesting = false;
    }
}

const Api = {
    refreshToken
}


async function handler2xxMessage(codeStatus, data){
  data = await data;
  if(codeStatus >= 200 && codeStatus < 300){ 
    data.info = messageCode({message: data}); 
    return data;
  }
  return data;
}


const messageCode = function({message}){
  if(!message) return
  message.originInfo = message.info; 

  switch(message.info){
    case('MAIL_SENT'): return i18n.t('Check your email')
    case('SUCCESS'): return i18n.t('Success')
    case('Queued'): return i18n.t('Queued')
    case('AlreadyQueued'): return i18n.t('Already Queued')
    default: message.info
  }
}

async function handler4xxError(codeStatus, data){
  data = await data;
  data.originMessage = data.message; 

  if(codeStatus >= 400 && codeStatus < 500){ 
    data.message = await errorCode({errors: data}); 
    return data;
  }
  if(codeStatus >= 500 && codeStatus < 600) {
    throw new Error(data.message);
  }
  return data;
}

const errorCode = async function({errors, message}){
  if(!errors) return 
  switch(errors.message){  
  case('USER_PASS_SIMPLE'): return i18n.t('Password is very simple')
  case('EMAIL_NOT_UNIQUE'): return i18n.t('The e-mail address you provided is already in use')
  case('USER_EMAIL_REQUIRED'): return i18n.t('Email is required')
  case('PASS_REQUIRED'): return i18n.t('Password is required')
  case('WRONG_EMAIL_FORMAT'): return i18n.t('Wrong email format')
  case('USER_NAME_REQUIRED'): return i18n.t('User name is required')
  case('FB_ID_NOT_UNIQUE'): return i18n.t('Facebook Id is not unique')
  case('G_ID_NOT_UNIQUE'): return i18n.t('Google Id is not unique')
  case('FB_TOKEN_REQUIRED'): return i18n.t('Facebook token is required')
  case('G_TOKEN_REQUIRED'): return i18n.t('Google token is required')
  case('FB_USER_REQUIRED'): return i18n.t('Facebook user is required')
  case('G_USER_REQUIRED'): return i18n.t('Google user is required')
  case('USER_NOT_FB'): return i18n.t('User registered, but not via Facebook')
  case('USER_NOT_G'): return i18n.t('User registered, but not via Google')
  case('INVALID_FB_TOKEN'): return i18n.t('Invalid Facebook token')
  case('INVALID_G_TOKEN'): return i18n.t('Invalid Google token')

  case('INVALID_EMAIL_PASS'): return i18n.t('Wrong email or password')
  case('SOCIAL_USER_EXISTS'): return i18n.t('User registered, but via other method')


  case('INVALID_USER_ROLE'): return i18n.t('INVALID_USER_ROLE')
  case('INVALID_USER_STATUS'): return i18n.t('INVALID_USER_STATUS')

  case('USER_NOT_FOUND'): return i18n.t('User not found')
  case('RESET_PASSWORD'): return i18n.t('Password not found, please reset it via "Forgot Password"')
  case('NO_AUTHORIZATION_HEADER_WAS_FOUND'): return i18n.t('No Authorization header was found')
  case('WRONG_AUTHORIZATION_FORMAT'): return i18n.t('Format is Authorization: Bearer [token]')
  case('NOT_UPDATED'): return i18n.t('Entity is not updated')
  case('INCORRECT_PARAMS'): return i18n.t('Incorrect parameters')
  case('ID_NOT_FOUND'): return i18n.t('Id item not found')
  case('NOT_UNIQUE'): return i18n.t('Not unique field(s) in form')
  case('NOT_FOUND'): return i18n.t('Resource is not found')
  case('NOT_AVAILABLE_PRODUCT'): return i18n.t('Not appropriate content for getting products automatically')

  case('WRONG_AUTHORIZATION_TOKEN'):
  case('No permission for this action'):
  case('INVALID_TOKEN'):{
    
    AuthStore.signout(() => {

      if(
        !(
          location.pathname.includes(paths.banner) || 
          location.pathname.includes(paths.popup) ||
          location.pathname.includes(paths.page) ||
          location.pathname.includes(paths.checkout)
        )
      ){
        location.href = paths.dashboard;
      }
    });
    return i18n.t('Invalid token')
  }
  case('TOKEN_EXPIRED'):
  case('USER_RIGHTS_CHANGED'): {
    await Api.refreshToken()
    throw new Error('UPD_OPTIONS')
  }
  
  default: {
    console.error(errors.message)
    return i18n.t('Server Error')
  }
  }
}


   /**
   * Returns a promise for fetching a URL
   *
   * @param {string} url The URL to fetch.
   * @param {object} payload The body to add to the POST request.
   * @returns {Promise.<Object>} The constructed promise.
   *
   */
  export function fetchQueue(path, payload = null, method = "POST", num = 2, raw = false, optionsHeader={}) {
    
    let options =  {
      mode: "cors",
      credentials: method != "GET" ? "include" : "omit",
      cache: "no-cache",
      method,
      headers: {
        'accept': 'application/json',
        'Authorization': `Bearer ${AuthStore.accessToken ? AuthStore.accessToken : ''}`
      },
    };

    if(payload){
      if(payload instanceof FormData){
        Object.assign(options, {body: payload})
      }else{
        Object.assign(options, 
          {
            body: JSON.stringify(payload),
            headers: {
              ...options.headers,
              'content-type': 'application/json',
              ...optionsHeader
            }
          }
        )
      }
    }

    if(raw)
      return createQueue(() => Promise.race([ fetch(new URL(`${host}:${port}${pathname}/${path}`).href, options) ]) , num);
   
    return createQueue((r) => {
      
      options.headers.Authorization =  `Bearer ${AuthStore.accessToken ? AuthStore.accessToken : ''}`;
      // upd in case it is staled
      return Promise.race([
          fetch(new URL(`${host}:${port}${pathname}/${path}`).href, options)
          .then(response => {
            
            let code = response.status,
                data = response.json();
            return {code, data}
          })
          .then( async ({code, data}) => {
            data = await handler2xxMessage(code, data);
            data = await handler4xxError(code, data);
            // console.log(data);
            return data
          })
        ])}
      , num);
  }

  /**
 *  Queue to make requests constantly until it success or max number of requests is reached.
 *
 * @export
 * @param {*} task
 * @param {number} [maxNumOfTry=5]
 * @returns {Promise.<Object>} The constructed promise.
 */
export function createQueue(task, maxNumOfTry = 5) {
  return new Promise((done, fail) => {
    const handleFailureResult = r => {
      maxNumOfTry--;
      if(maxNumOfTry > 0){
        setTimeout(getNextTask, settings.TIMEOUT_QUEUE, r);
      }else{
        console.error('fail to load')
        fail();
      }
    };
    const getNextTask = (r) => task(r).then(done).catch(handleFailureResult);
    getNextTask();
  });
}

export const getRates = async () => {
  try {
    let data = fetch('https://comin.co/system/api/elastic/exccy')
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          return data.data;
        });
    return data
  }catch (e){
    console.error(e)
  }
}



   /**
   * Returns a promise for fetching a URL
   *
   * @param {string} url The URL to fetch.
   * @param {object} payload The body to add to the POST request.
   * @returns {Promise.<Object>} The constructed promise.
   *
   */
  export function upload(path, payload,  num = 2 ) {
    
    let options =  {
      mode: 'cors',
      credentials: 'omit',
      cache: "no-cache",
      method: 'POST',
      body: payload,
      headers: {
        'accept': 'application/json',
        'Authorization': `Bearer ${AuthStore.accessToken ? AuthStore.accessToken : ''}`
      },
    };

    return createQueue(() => 
        Promise.race([
          fetch(new URL(`${host}:${port}${pathname}/${path}`).href, options)
          .then(response => {
            
            let code = response.status,
                data = response.json();
            return {code, data}
          })
          .then( async ({code, data}) => {
            data = await handler2xxMessage(code, data);
            data = await handler4xxError(code, data);
            // console.log(data);
            return data
          })
        ])
      , num);
  }


  /** helper for alleviate managing process process state while requests
   * 
   * @param {Object.<string, *>} state Object that changes
   * @param {Object} action Action creator object
   * @param {string} action.type Action creator type
   * @param {*} action.payload Action creator payload
   * @return {void}
  */
  export const requestMetaReducer = (state, action) => {
    switch (action.type) {
      case 'loading':
        
        state.requestingCount++;
        state.requesting = true;
        state.error = null;
        state.info = null;
        return
      case 'loaded':

        state.requesting = false;

        return 
      case 'error':

          state.error = action.payload;
          return
      case 'info':

          state.info = action.payload;
          return
      case 'resetCount':
          state.requestingCount = 0;
          return
      default:
        throw new Error();
    }

  }


  

@Service('APIClass')
export class APIClass {
    refreshToken = refreshToken;
    fetchQueue = fetchQueue;
    requestMetaReducer = requestMetaReducer;
}

Container.set('Api', new APIClass)
export default Api;
